(function () {
  'use strict';

  // ──────────────────────────────────────────────────────────────────────
  // Mobile nav toggle
  // ──────────────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (!t) return;
    var nav = document.querySelector('[data-nav]');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // ──────────────────────────────────────────────────────────────────────
  // Drawer system (cart + quote share infrastructure)
  // ──────────────────────────────────────────────────────────────────────
  var overlay = document.querySelector('[data-drawer-overlay]');
  var openDrawer = null;

  function showDrawer(el) {
    if (!el) return;
    if (openDrawer && openDrawer !== el) hideDrawer();
    openDrawer = el;
    el.hidden = false;
    if (overlay) overlay.hidden = false;
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('drawer-locked');
    });
    var firstFocus = el.querySelector('input, button, a, textarea');
    if (firstFocus) setTimeout(function () { firstFocus.focus(); }, 280);
  }
  function hideDrawer() {
    if (!openDrawer) return;
    var el = openDrawer;
    el.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('drawer-locked');
    setTimeout(function () {
      el.hidden = true;
      if (overlay) overlay.hidden = true;
    }, 280);
    openDrawer = null;
  }

  // Trigger handlers
  document.addEventListener('click', function (e) {
    var openCart = e.target.closest('[data-cart-open]');
    // Auto-trigger quote drawer for any anchor pointing at the request-a-quote
    // page, OR any element explicitly tagged [data-quote-trigger].
    var openQuote = e.target.closest('[data-quote-trigger]') ||
                    e.target.closest('a[href*="/pages/request-a-quote"]');
    var close = e.target.closest('[data-drawer-close]');
    var overlayClick = e.target === overlay;

    if (openCart) {
      e.preventDefault();
      var cd = document.getElementById('CartDrawer');
      refreshCartDrawer().then(function () { showDrawer(cd); });
      return;
    }
    if (openQuote) {
      // On the contact + request-a-quote pages the form is inline; let the
      // link follow its href instead of opening the drawer.
      var bc = document.body.className || '';
      if (bc.indexOf('template-page-contact') > -1 || bc.indexOf('template-page-request-a-quote') > -1) return;
      e.preventDefault();
      var qd = document.getElementById('QuoteDrawer');
      // If trigger has data-sku (PDP quote button), prefill the form
      var sku = openQuote.getAttribute('data-sku') || '';
      if (!sku) {
        // Also accept ?sku=... in the href as a convenience
        var href = openQuote.getAttribute('href') || '';
        var m = href.match(/[?&]sku=([^&]+)/);
        if (m) sku = decodeURIComponent(m[1]);
      }
      var skuInput = qd && qd.querySelector('[data-quote-sku]');
      if (skuInput && sku) skuInput.value = sku;
      showDrawer(qd);
      return;
    }
    if (close || overlayClick) {
      hideDrawer();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) hideDrawer();
  });

  // After a contact-form post-back, Shopify re-renders the page with
  // form.posted_successfully? = true. If that success card is inside the quote
  // drawer, auto-reopen the drawer so the confirmation is visible. Skipped on
  // /pages/contact and /pages/request-a-quote since those have inline forms
  // showing their own confirmation already.
  document.addEventListener('DOMContentLoaded', function () {
    var bc = document.body.className || '';
    if (bc.indexOf('template-page-contact') > -1 || bc.indexOf('template-page-request-a-quote') > -1) return;
    var qd = document.getElementById('QuoteDrawer');
    if (qd && qd.querySelector('[data-form-success]')) {
      showDrawer(qd);
    }
  });

  // ──────────────────────────────────────────────────────────────────────
  // Cart drawer rendering (fetches /cart.js for the latest state)
  // ──────────────────────────────────────────────────────────────────────
  function moneyHKD(cents) {
    var n = (cents / 100).toLocaleString('en-HK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return 'HKD $' + n;
  }
  function refreshCartDrawer() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Update count badge
        var counts = document.querySelectorAll('[data-cart-count]');
        counts.forEach(function (c) { c.textContent = cart.item_count; });
        var dCount = document.querySelector('[data-cart-drawer-count]');
        if (dCount) dCount.textContent = cart.item_count;

        var empty = document.querySelector('[data-cart-drawer-empty]');
        var items = document.querySelector('[data-cart-drawer-items]');
        var foot  = document.querySelector('[data-cart-drawer-foot]');
        var subtotal = document.querySelector('[data-cart-drawer-subtotal]');

        if (cart.item_count === 0) {
          if (empty) empty.hidden = false;
          if (items) items.hidden = true;
          if (foot)  foot.hidden  = true;
          return cart;
        }

        if (empty) empty.hidden = true;
        if (items) {
          items.hidden = false;
          items.innerHTML = cart.items.map(function (it) {
            var img = it.image ? '<img src="' + it.image + '&width=200" alt="">' : '';
            var variant = it.variant_options && it.variant_options[0] !== 'Default Title'
              ? '<div class="cart-drawer__item-variant">' + it.variant_options.join(' · ') + '</div>'
              : '';
            return [
              '<div class="cart-drawer__item">',
              '  <a class="cart-drawer__item-img" href="' + it.url + '">' + img + '</a>',
              '  <div class="cart-drawer__item-info">',
              '    <a class="cart-drawer__item-title" href="' + it.url + '">' + it.product_title + '</a>',
              variant,
              '    <div class="cart-drawer__item-price">' + moneyHKD(it.original_line_price) + ' · qty ' + it.quantity + '</div>',
              '  </div>',
              '  <a class="cart-drawer__item-remove" href="/cart/change?line=' + (cart.items.indexOf(it) + 1) + '&quantity=0" aria-label="Remove">×</a>',
              '</div>',
            ].join('');
          }).join('');
        }
        if (foot) foot.hidden = false;
        if (subtotal) subtotal.textContent = moneyHKD(cart.total_price);
        return cart;
      });
  }

  // Hook PDP form so add-to-cart opens the drawer instead of navigating
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#PdpForm');
    if (!form) return;
    e.preventDefault();
    var addBtn = form.querySelector('[data-pdp-add]');
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding...'; }
    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json' },
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status && data.status >= 400) {
        if (addBtn) {
          addBtn.textContent = data.description || 'Could not add';
          setTimeout(function () { addBtn.textContent = 'Add to cart'; addBtn.disabled = false; }, 2400);
        }
        return;
      }
      if (addBtn) {
        addBtn.textContent = 'Added ✓';
        setTimeout(function () { addBtn.textContent = 'Add to cart'; addBtn.disabled = false; }, 1600);
      }
      var cd = document.getElementById('CartDrawer');
      refreshCartDrawer().then(function () { showDrawer(cd); });
    })
    .catch(function () {
      if (addBtn) { addBtn.textContent = 'Try again'; addBtn.disabled = false; }
    });
  });

  // ──────────────────────────────────────────────────────────────────────
  // Quote form helpers
  // Shopify's {% form 'contact' %} only reliably accepts a fixed set of
  // field names (name, email, phone, company, body, subject). Custom
  // field names like contact[interests] or contact[sku] get rejected
  // with "is invalid". So we keep the chips and SKU input as pure UI
  // and concatenate their values into contact[body] on submit.
  // ──────────────────────────────────────────────────────────────────────
  function gatherChipSummary(form) {
    var lines = [];
    var groups = form.querySelectorAll('[data-chip-group]');
    groups.forEach(function (g) {
      var picked = Array.prototype.map.call(
        g.querySelectorAll('[data-chip-option]:checked'),
        function (cb) { return cb.value; }
      );
      if (picked.length) lines.push('Interests: ' + picked.join(', '));
    });
    var merge = form.querySelectorAll('[data-merge-into-body]');
    merge.forEach(function (el) {
      var v = (el.value || '').trim();
      if (!v) return;
      var label = el.getAttribute('data-merge-label') || (el.id || 'Note');
      // Best-effort pretty label from the input's id
      if (label === el.id && el.previousElementSibling && el.previousElementSibling.tagName === 'LABEL') {
        label = el.previousElementSibling.textContent.trim();
      }
      lines.push(label + ': ' + v);
    });
    return lines;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    // Only handle Shopify contact forms (skip product, search, login, etc.)
    var typeInput = form.querySelector('input[name="form_type"]');
    if (!typeInput || typeInput.value !== 'contact') return;

    var body = form.querySelector('textarea[name="contact[body]"]');
    if (!body) return;
    var extras = gatherChipSummary(form);
    if (!extras.length) return;
    var existing = (body.value || '').trim();
    body.value = (existing ? existing + '\n\n' : '') + extras.join('\n');
  });
})();
